import queryString from 'query-string'

import type { ParsedUrlQuery } from 'querystring'
import type { QueryClient } from 'react-query'

const getFirstValue = (value: string | string[] | undefined) =>
  Array.isArray(value) ? value[0] : value

const INVALID_QUERY_VALUES = new Set(['undefined', 'null'])

export const getSerializableQueryValue = (
  value: string | string[] | undefined
) => {
  const firstValue = getFirstValue(value)

  if (typeof firstValue !== 'string') {
    return undefined
  }

  if (!firstValue.trim()) {
    return undefined
  }

  if (INVALID_QUERY_VALUES.has(firstValue.trim().toLowerCase())) {
    return undefined
  }

  return firstValue
}

export const getQueryLabel = (
  value: string | string[] | undefined,
  fallback: string
) => getSerializableQueryValue(value) ?? fallback

export const getModuleReturnUrl = (
  query: ParsedUrlQuery,
  materialId?: string
) => {
  const moduleId = getFirstValue(query.modul)
  const topicId = getFirstValue(query.topik)
  const expandedMaterialId = materialId ?? getFirstValue(query.materi)

  if (getFirstValue(query.return_view) === 'topic') {
    return (
      `/pelatihan-mandiri/topik/${topicId}?` +
      queryString.stringify({
        modul: moduleId,
        from: getFirstValue(query.from),
        menuId: getFirstValue(query.menuId),
        materi: expandedMaterialId,
      })
    )
  }

  return (
    `/pelatihan-mandiri/modul/${moduleId}?` +
    queryString.stringify({
      topik: topicId,
      topik_name: getSerializableQueryValue(query.topik_name),
      from: getFirstValue(query.from),
      menuId: getFirstValue(query.menuId),
      materi: expandedMaterialId,
    })
  )
}

export const invalidateLearningProgress = async (
  queryClient: QueryClient,
  moduleId?: string,
  topicId?: string
) => {
  const queryKeys = [
    moduleId ? `/microlearnings/modules/${moduleId}/materials` : null,
    moduleId ? `/microlearnings/modules/${moduleId}/preview` : null,
    topicId ? `/microlearnings/topics/${topicId}/progress` : null,
  ].filter(Boolean) as string[]

  await Promise.all(
    queryKeys.map((queryKey) => queryClient.invalidateQueries(queryKey))
  )
}
